export function defaultUser(){
  return {
    id: '',
    username: '',
    password: '',
    profile: {
      pic: '',
      nickname: '',
      name: ''
    }
  }
}